import { createStore } from '@aibees/shared/store';
import { SearchListCardStoreData as StoreData } from './types';

const useSearchListCardStore = createStore<StoreData>(
  'search-list-card',
  (set) => ({
    name: null,
    setName: (name) => set({ name }),

    grouping: '',
    setGrouping: (grouping) => set({ grouping }),

    title: undefined,
    setTitle: (title) => set({ title }),

    visibility: null,
    setVisibility: (visibility) => set({ visibility }),

    empty: false,
    setEmpty: (empty) => set({ empty }),

    isLoading: false,
    setIsLoading: (isLoading) => set({ isLoading }),

    state: false,
    setState: (value) => set({ state: value }),
  })
);

export default useSearchListCardStore;
